export const MAIL_CREATED = 'MAIL_CREATED'